import React, { Component } from 'react';
import _ from 'lodash';
import { isSome } from 'core/utils';

class CommandCell extends Component {
    render() {
        const {
            rowType,
            dataItem,
            actions,
            items,
            actionsComponent,
            t,
            authorization
        } = this.props;

        if (actionsComponent) {
            const wrap = { component: actionsComponent };
            return (
                <wrap.component
                    actions={actions}
                    item={dataItem}
                    items={items}
                    t={t}
                />
            );
        }

        const iconItems = items || [
            {
                title: 'Edit',
                icon: 'u-icon u-icon--sml u-icon--edit',
                action: actions.onEdit,
                authorized: authorization ? authorization.update : true
            },
            {
                title: 'Delete',
                icon: 'u-icon u-icon--sml u-icon--delete',
                action: actions.onDelete,
                authorized: authorization ? authorization.delete : true,   
                className:'is-delete'             
            },
            {
                title: 'Preview',
                icon: 'u-icon u-icon--preview u-icon--sml',
                action: actions.onPreview,
                authorized: authorization ? authorization.read : true                
            }
        ];
        if (!_.some(iconItems, i => isSome(i.action))) {
            return null;
        }

        if (rowType !== 'data') {
            return null;
        }

        return (
            <td>
                <div className="table__icons">
                    {_.map(iconItems, (item, idx) => {
                        return item.action && item.authorized ? (
                            <button key={idx} type="button" className={`btn btn--icon ${item.className}`} onClick={() => item.action(dataItem)}>
                            <i
                                className={`${item.icon} align--v--middle ${
                                    idx !== 0 ? ' spc--left--sml ' : ''
                                }`}
                                title={item.title}
                                
                            />
                            </button>
                        ) : null;
                    })}
                </div>
            </td>
        );
    }
}

export default CommandCell;
